import mock from '../mock'

// POST method implementation:
async function getData(url = '', auth_token) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    // mode: 'cors', // no-cors, *cors, same-origin
    // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    // credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth_token
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }
    // redirect: 'follow', // manual, *follow, error
    // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    // body: JSON.stringify(data) // body data type must match "Content-Type" header
  })
  const param = response.json()
  return param// parses JSON response into native JavaScript objects
}

async function postData(url = '', data, auth_token) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    // mode: 'cors', // no-cors, *cors, same-origin
    // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    // credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth_token
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    // redirect: 'follow', // manual, *follow, error
    // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  })
  const param = response.json()
  return param// parses JSON response into native JavaScript objects
}

// ------------------------------------------------
// GET: Return Invoice List
// ------------------------------------------------
mock.onGet('/issues/list').reply(async config => {
  // console.log("params form mock: ", config)
  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn, userId = null } = config

  /* eslint-enable */
  const toggleState = localStorage.getItem('toggleState')
  const complaintStatus = config.complaint_status || ''
  const params = new URLSearchParams({
    complaint_status: complaintStatus,
    page: String(page),
    perPage: String(perPage),
    q,
    sort: sort || 'desc',
    sortColumn: sortColumn || 'createdAt'
  })
  if (userId) params.set('userId', userId)
  const path = toggleState === 'Pro' ? 'complaints_pro' : 'complaints'
  const data = await getData(
    `${process.env.REACT_APP_API_URL}/${path}?${params.toString()}`,
    config.headers.Authorization
  )

  return [
    200,
    {
      allData: data.data || [],
      total: data.total || 0,
      invoices: data.data || []
    }
  ]
})

mock.onGet('/apps/invoice/allInvoices').reply(async config => {
  // eslint-disable-next-line object-curly-newline
  const { id } = config
  const _id = id.id
  /* eslint-enable */
  const toggleState = localStorage.getItem('toggleState')
  let data = {}
  if (toggleState === 'Classic') {
    data = await getData(`${process.env.REACT_APP_API_URL}/complaints`, config.headers.Authorization)
    
  } else if (toggleState === 'Pro') {
    data = await getData(`${process.env.REACT_APP_API_URL}/complaints_pro`, config.headers.Authorization)
  }
  // const data = await getData(`${process.env.REACT_APP_API_URL}/complaints`, config.headers.Authorization)
  const index = data.data.findIndex(e => e._id === _id)
  const res = data.data[index]
  /* eslint-enable  */

  return [200, { res }]
})

// ------------------------------------------------
// GET: Return Single Invoice
// ------------------------------------------------
mock.onGet(/\/api\/invoice\/invoices\/\d+/).reply(async config => {

  const invoiceId = config.url.substring(config.url.lastIndexOf('/') + 1)

  console.log("invoiceif: ", invoiceId)

  const toggleState = localStorage.getItem('toggleState')
  let data = {}
  if (toggleState === 'Classic') {
    data = await getData(`${process.env.REACT_APP_API_URL}/complaints`, config.headers.Authorization)
    
  } else if (toggleState === 'Pro') {
    data = await getData(`${process.env.REACT_APP_API_URL}/complaints_pro`, config.headers.Authorization)
  }
  // const data = await getData(`${process.env.REACT_APP_API_URL}/complaints`, config.headers.Authorization)

  const invoiceIndex = data.data.findIndex(e => e._id === invoiceId)

  const responseData = {
    invoice: data.data[invoiceIndex],
    paymentDetails: {
      totalDue: '$12,110.55',
      bankName: 'American Bank',
      country: 'United States',
      iban: 'ETD95476213874685',
      swiftCode: 'BR91905'
    }
  }

  return [200, responseData]
})

// ------------------------------------------------
// UPDATE: Update Status
// ------------------------------------------------
mock.onPost('/apps/statusChange').reply(async config => {
  //Get parameters
  const { id, value } = JSON.parse(config.data)
  // Parameter to be passed to post api as body
  const param = { id, complaint_status: value.value }
  //Change Status Api Call
  const data = await postData(`${process.env.REACT_APP_API_URL}/complaint/change_status`, param, config.headers.Authorization)
  //return response
  return [200, data]
})

// ------------------------------------------------
// DELETE: Deletes Invoice
// ------------------------------------------------
mock.onDelete('/apps/invoice/delete').reply(config => {
  // Get invoice id from URL
  let invoiceId = config.id

  // Convert Id to number
  invoiceId = Number(invoiceId)

  const invoiceIndex = data.invoices.findIndex(t => t.id === invoiceId)
  data.invoices.splice(invoiceIndex, 1)

  return [200]
})

// ------------------------------------------------
// GET: Return Clients
// ------------------------------------------------
mock.onGet('/api/invoice/clients').reply(() => {
  const clients = data.invoices.map(invoice => invoice.client)
  return [200, clients.slice(0, 5)]
})
